(function ($, Drupal, once) {
  'use strict';

  Drupal.behaviors.componentNavDropdown = {
    attach: function (context, settings) {
      $(once('componentNavDropdown', 'button.nav-dropdown')).each(function (index) {
        $(this).click(function () {
          if (!$(this).parent().parent().hasClass('mobile')) {
            $(this).toggleClass('mega-menu__dropdown-button--expanded');
            $(this).find('svg').toggleClass('rotate-90 -rotate-90');
            $(this).next('ul').toggleClass('hidden');
          }
        });
      });
      $(document).on('click', 'body *', function (event) {
        if (!$(event.target).closest('button.nav-dropdown').length) {
          $('button.nav-dropdown svg').removeClass('-rotate-90');
          $('button.nav-dropdown svg').addClass('rotate-90');
          $('button.nav-dropdown').next('ul').addClass('hidden');
          $('button.nav-dropdown').removeClass('mega-menu__dropdown-button--expanded');
        }
      });
      $('.child-arcb-main-menu').parent('nav').addClass('child');
    }
  };

})(jQuery, Drupal, once);
